module.exports = __webpack_public_path__ + "static/media/beam-mascot.ec3cde70.svg";